import type { ImageTemplate } from '../Image'

import styles from './styles.module.scss'
import type { ListingPictureSize } from './types'

export const SIZE_CLASS_MAP = {
  small: styles.pictureSmall,
  medium: styles.pictureMedium,
  large: styles.pictureLarge,
  extraLarge: styles.pictureExtraLarge,
} as const

export const SIZE_TEMPLATE_MAP: Record<ListingPictureSize, ImageTemplate> = {
  small: 'listing-xs',
  medium: 'listing-xs',
  large: 'listing-xs',
  extraLarge: 'listing-sm',
}
